import React from "react"
import { Modal } from "@mimber/ui-web"
import { QuickScheduleAnnouncementForm } from "@/components/forms"
import type { ScheduleAnnouncementModalProps } from "./ScheduleAnnouncementModal.types"

export const ScheduleAnnouncementModal: React.FunctionComponent<
  ScheduleAnnouncementModalProps
> = ({ announcement, onSuccess, ...modalProps }) => {
  const externalOnCancel = (modalProps as { onCancel?: () => void }).onCancel

  return (
    <Modal title="Schedule Announcement" footer={null} {...modalProps}>
      {(close) => (
        <QuickScheduleAnnouncementForm
          announcement={announcement}
          onSuccess={() => {
            onSuccess?.()
            close()
            externalOnCancel?.()
          }}
          onCancel={() => {
            close()
            externalOnCancel?.()
          }}
        />
      )}
    </Modal>
  )
}
